import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { WeatherNow } from '@shared/types';

export function useWeather() {
  const [weather, setWeather] = useState<WeatherNow | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<{ weather: WeatherNow }>('/weather')
      .then((res) => setWeather(res.weather))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return { weather, error, loading };
}
